var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"width":"120%","src":"https://agmertaxi.pl/images/logo.png"}})]),_c('h2',[_vm._v("Dziękujemy za potwierdzenie serwisu!")]),_vm._v(" Twój serwis został potwierdzony, prosimy o punktualny przyjazd we wskazane miejsce. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }